/*
  File: src/api/products.js
  Purpose: Products API client with methods for fetching products
  Notes:
  - Uses shared apiClient base URL and credentials.
  - Supports fetching products by character, SKU, and other filters.
*/
import { apiClient } from '../auth/api';

export const ProductsAPI = {
    async getByCharacter(characterName, { limit = 50, offset = 0 } = {}) {
        const params = { character: characterName };
        if (limit != null) params.limit = limit;
        if (offset != null) params.offset = offset;
        const { data } = await apiClient.get('/products/by-character', { params });
        return data;
    },

    async list({ limit = 50, offset = 0, ...filters } = {}) {
        const params = { limit, offset, ...filters };
        const { data } = await apiClient.get('/products', { params });
        return data;
    },

    async getById(productId) {
        const { data } = await apiClient.get(`/products/${productId}`);
        return data;
    },

    async getBySku(sku, { includeSuggested = false, character } = {}) {
        const params = { include_suggested: includeSuggested };
        if (character) params.character = character;
        const { data } = await apiClient.get(`/products/by-sku/${encodeURIComponent(sku)}`, { params });
        return data;
    }
};

export default ProductsAPI;